import { createSlice } from "@reduxjs/toolkit";

export const articulosSlice = createSlice({
    name: 'articulos',
    initialState: {
        allArticulos: [],
        articuloId:[],
        articuloNew: {}
    },
    reducers: {
      allArticulos: (state, {payload}) => {
        state.allArticulos = payload
      },
      articuloId: (state, {payload}) => {
        state.articuloId = payload
      },
      articuloNew: (state, {payload}) => {
        state.articuloNew = payload
      }  
    }
})

export const { allArticulos, articuloId, articuloNew } = articulosSlice.actions;

export default articulosSlice.reducer;